module.exports = __webpack_public_path__ + "img/header.700cd2dc.png";